<template>
  <div class="why-love-you">
    <DefSwiper :settings="settings">
      <SwiperSlide v-for="item in result.items">
        <a v-if="item.html" :href="item.link">
          <DefInsertTildaSlider :result="item.html" />
        </a>
        <a v-else-if="item.video" :href="item.link">
          <DefVideo :result="item.video" />
        </a>

        <a v-else-if="item.pictures" :href="item.link">
          <DefPicture :result="item.pictures" />
        </a>
        <a v-else-if="item.animation" :href="item.link">
          <DefPicture :result="item.animation" />
        </a>
      </SwiperSlide>
    </DefSwiper>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { SwiperSlide } from 'swiper/vue';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefSwiper from '@components/Def/DefSwiper/DefSwiper.vue';
import DefPicture from '../Def/DefPicture/DefPicture';
import DefInsertTildaSlider from '../Def/DefInsertTilda/DefInsertTildaSlider';

const { result } = defineProps(['result']);

const settings = {
  slidesPerView: 1,
};
</script>

<script>
export default {
  name: 'WhyLoveYou',
};
</script>

<style lang="scss" scoped>
.why-love-you {
  margin-bottom: 56px;
  @include point-md {
    margin-bottom: 80px;
  }
  @include point-lg {
    margin-bottom: 100px;
  }
  :deep(.def-picture) {
    img {
      width: 100%;
    }
  }
  :deep(.def-video) {
    width: 100%;
  }
  :deep(.swiper-wrapper) {
    align-items: center;
  }
  :deep(.def-swiper-button-prev) {
    left: 50px;
  }
  :deep(.def-swiper-button-next) {
    right: 50px;
  }
}
</style>
